import {$events} from "../../helpers/events";
import {$dom} from "../../helpers/dom";
import variables from "../../variables";
import Component from "../../classes/Component";

const {removeClass, addClass, getAll, hasClass} = $dom

const groupSelector = '.js-group-tab'
const tabsButtonSelector = '.js-tabs-button'
const tabsLayoutSelector = '.js-tabs-layout'

const activeTab = 'detail__tabs-switcher-active'

export default function () {
    const handleChangeTab = (e) => {
        changeActiveTabButton(e)

        changeActiveTabLayout()
    }

    const changeActiveTabButton = (e) => {
        const buttons = getAll(tabsButtonSelector)

        buttons.forEach(item => removeClass(item, activeTab))

        addClass(e.target.closest('button'), activeTab)
    }

    const changeActiveTabLayout = () => {
        const layouts = getAll(tabsLayoutSelector)

        layouts.forEach(item => {
            if (hasClass(item, variables.classNames.hidden)) {
                removeClass(item, variables.classNames.hidden)
            } else if (!hasClass(item, variables.classNames.hidden)) {
                addClass(item, variables.classNames.hidden)
            }
        })
    }

    return new Component({
        name: 'tab',
        requiredTargets: [groupSelector, tabsButtonSelector, tabsLayoutSelector],
        onInit() {
            $events.delegate.on('click', tabsButtonSelector, handleChangeTab)
        },
        onDestroy() {
            $events.delegate.off('click', tabsButtonSelector, handleChangeTab)
        },
    })

};